import React, { useEffect, useState } from 'react';
import { map, prop } from 'ramda';
import { localise } from '../../../../services/lang/lang';
import PageContent from '../../../modules/PageContent/PageContent';
import PageHeader from '../../../modules/PageHeader';
import { useTokens } from '../../../../context/TokenProvider';
import { unwrapModel } from '../../../../services/api/unwrapModel';
import { useGetAllInspectionStatusesSuspense } from '../../../../services/api/generated/client';
import InspectionListingContent from './InspectionListingContent';
import { useInspectionListingContext } from './InspectionListingProvider';
import InspectionListingHeader from './InspectionListingHeader';
import useSearch from '../../../../hooks/useSearch';
import usePages from '../../../../hooks/usePages';
import { INSPECTION_LIST_TABLE_HEADERS } from '../../../modules/InspectionsTable/InspectionsTable';
import { useLocalStorage } from '../../../../hooks/useLocalStorage';
const InspectionListingPageWrapper = () => {
    const tokens = useTokens();
    const { status, scope } = useInspectionListingContext();
    const [selectedColumns, setSelectedColumns] = useLocalStorage('inspection_listing_table__selected_columns', map(prop('key'), INSPECTION_LIST_TABLE_HEADERS));
    const { setPage, ...restOfPage } = usePages();
    useEffect(() => {
        setPage(1);
    }, [setPage, status, scope]);
    const [selectedActionIds, setSelectedActionIds] = useState(undefined);
    const { searchQuery, debouncedSetSearchQuery } = useSearch(() => {
        setPage(1);
    });
    const { data: statusResponse } = useGetAllInspectionStatusesSuspense({
        query: { staleTime: Infinity },
    });
    const statuses = unwrapModel(statusResponse);
    if (!statuses)
        return null;
    const title = statuses.find((statusObj) => statusObj.id === status)?.name ??
        localise('DASHBOARD');
    return (React.createElement(React.Fragment, null,
        React.createElement(PageHeader, { "data-testid": "inspection_listing__page_header", align: "start", pb: tokens.Spacing06, title: title },
            React.createElement(InspectionListingHeader, { selectedColumns: selectedColumns, onColumnFilterApply: (values) => {
                    setSelectedColumns(values);
                }, onActionFilterApply: (values) => {
                    setPage(1);
                    setSelectedActionIds(values);
                }, selectedActionIds: selectedActionIds, onSearch: debouncedSetSearchQuery, statuses: statuses })),
        React.createElement(PageContent, null,
            React.createElement(InspectionListingContent, { ...restOfPage, selectedActionIds: selectedActionIds, selectedColumns: selectedColumns, searchQuery: searchQuery }))));
};
export default InspectionListingPageWrapper;
